export const SET_INBOUND_DATA = "SET_INBOUND_DATA";
export const SET_PAGINATION = "SET_INBOUND_PAGINATION";
export const SET_SORT = "SET_INBOUND_SORT";

export const SET_OUTBOUND_DATA = "SET_OUTBOUND_DATA";
